import React from "react";
import styles from "./MineAndGemShow.module.css";
import { useSelector } from "react-redux";
import darkAlien from "../../images/darkAlien.webp";
import darkSun from "../../images/darkSun.webp";
import { arrayLength } from "../../config";
const MineAndGemShow = ({ value }) => {
  const gameData = useSelector((state) => state.gameData);

  return (
    <div className={styles.controlGroup}>
      <div className={styles.containerLeft}>
        <label className={styles.inputLabel}>Mines</label>
        <div className={styles.wrapper}>
          <span> {value}</span>
          <img src={darkAlien} alt="darkAlien" className={styles.darkAlien} />
        </div>
      </div>
      <div className={styles.containerRight}>
        <label className={styles.inputLabel}>Gems</label>
        <div className={styles.wrapper}>
          {arrayLength - value - gameData.openedIndexes.length}
          <img src={darkSun} alt="darkSun" className={styles.darkSun} />
        </div>
      </div>
    </div>
  );
};

export default MineAndGemShow;
